import { render } from "./StudentsFlightPracticeView.vue?vue&type=template&id=6e06e9dd&scoped=true"
import script from "./StudentsFlightPracticeView.vue?vue&type=script&lang=js"
export * from "./StudentsFlightPracticeView.vue?vue&type=script&lang=js"

import "./StudentsFlightPracticeView.vue?vue&type=style&index=0&id=6e06e9dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e06e9dd"]])

export default __exports__